import * as types from '@actions/actionTypes';

export const setMenuOpenedAction = (payload: boolean) => ({
  type: types.SET_MENU_OPENED,
  payload,
});
